module.exports = __webpack_public_path__ + "static/media/invoiceimage.4a4162c5.png";